import {forwardRef} from 'react';
import {SnackbarProps, IconButton, Box, Typography} from '@mui/material';
import {FaInfoCircle, FaTimesCircle} from 'react-icons/fa';
import {AppEllipsisTypography} from 'components/typographies';
import {useSnackbar} from 'notistack';

interface AppNotificationProps extends SnackbarProps {
    variant?: 'success' | 'error' | 'info' | 'warning';
    message: string;
    action?: React.ReactNode;
}

// icons and styles
// const iconMap = {
//     success: <FaCheckCircle size={20} style={{color: '#4caf50', marginRight: 8}} />,
//     error: <FaTimesCircle size={20} style={{color: '#f44336', marginRight: 8}} />,
//     info: <FaInfoCircle size={20} style={{color: '#2196f3', marginRight: 8}} />,
//     warning: <FaExclamationTriangle size={20} style={{color: '#ff9800', marginRight: 8}} />,
// };

// const variantStyles = {
//     success: {background: '#d4edda', color: '#155724'},
//     error: {background: '#f8d7da', color: '#721c24'},
//     info: {background: 'white', color: '#0c5460'},
//     warning: {background: '#fff3cd', color: '#856404'},
// };

export const AppNotification = forwardRef<HTMLDivElement, AppNotificationProps>(
    (
        {
            message,
            open,
            autoHideDuration = 5000,
            anchorOrigin = {vertical: 'top', horizontal: 'right'},
            variant = 'info',
            id,
            ...props
        },
        ref,
    ) => {
        const {closeSnackbar} = useSnackbar();
        const handleClose = () => {
            if (id) {
                closeSnackbar(id); // <-- close that specific snackbar
            }
        };
        return (
            <div ref={ref}>
                <Box
                    onClick={e => {
                        e.stopPropagation();
                        if (props.action) {
                            window.location.assign(props.action.toString());
                        }
                    }}
                    sx={{
                        backgroundColor: 'white',
                        padding: 1,
                        borderRadius: 2,
                        boxShadow: 3,
                        minWidth: 300,
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                >
                    {/* Top Row: Icon + Message + Close */}
                    <Box sx={{display: 'flex', alignItems: 'start'}}>
                        <FaInfoCircle size={20} style={{color: '#2196f3', marginRight: 8, marginTop: 4}} />

                        <Box sx={{flexGrow: 1}}>
                            <Typography variant="subtitle2" sx={{fontWeight: 600}}>
                                New Notification
                            </Typography>
                            <AppEllipsisTypography
                                variant="body2"
                                hideDetails
                                whiteSpace="normal"
                                text={message}
                                maxLetters={150}
                            />
                        </Box>

                        <IconButton
                            size="small"
                            aria-label="close"
                            color="inherit"
                            onClick={e => {
                                e.stopPropagation();
                                handleClose();
                            }}
                            sx={{alignSelf: 'start'}}
                        >
                            <FaTimesCircle />
                        </IconButton>
                    </Box>

                    {/* Bottom Right Action */}
                    {/* {props.action && <Box sx={{display: 'flex', justifyContent: 'flex-end'}}>{props.action}</Box>} */}
                </Box>
            </div>
        );
    },
);

AppNotification.displayName = 'AppNotification'; // <-- Important for React DevTools

export default AppNotification;
